import React, { useState } from 'react';
import Breadcrumb from '../../components/Breadcrumb';

// Import images from assets
import skillLab1 from '../../assets/img/skill/IMG-20250604-WA0068.jpg';
import skillLab2 from '../../assets/img/skill/IMG-20250604-WA0069.jpg';
import skillLab3 from '../../assets/img/skill/IMG-20250604-WA0070.jpg';
import skillLab4 from '../../assets/img/skill/IMG-20250604-WA0071.jpg';
import skillLab5 from '../../assets/img/skill/WhatsApp Image 2025-06-04 at 14.09.01_bf0ef1e9.jpg';
import skillLab6 from '../../assets/img/skill/WhatsApp Image 2025-06-04 at 14.09.04_e7bd854f.jpg';
import skillLab7 from '../../assets/img/skill/WhatsApp Image 2025-06-04 at 14.09.05_4ab3ce25.jpg';
import skillLab8 from '../../assets/img/skill/WhatsApp Image 2025-06-04 at 14.09.05_d40dc594.jpg';


const SkillLab = () => {
  const galleryImages = [skillLab1, skillLab2, skillLab3, skillLab4, skillLab5, skillLab6, skillLab7, skillLab8];
  const [selectedImage, setSelectedImage] = useState(null);

  return (
    <main style={{ fontFamily: 'Segoe UI, sans-serif', backgroundColor: '#f5f5f5', paddingBottom: '40px' }}>
      {/* Breadcrumb with modern background */}
      <div style={{
        color: 'white',
        boxShadow: 'inset 0 0 0 2000px rgba(0, 0, 0, 0.4)'
      }}>
        <Breadcrumb title="Skill Lab (RIC)" />
      </div>

      {/* Content Section */}
        <section style={{ maxWidth: '1400px', margin: '50px auto', padding: '0 20px' }}>
        <div style={{
          backgroundColor: '#fff',
          padding: '40px',
          borderRadius: '16px',
          boxShadow: '0 12px 24px rgba(0, 0, 0, 0.1)'
        }}>
          <h2 style={{ fontSize: '2.2rem', color: '#b91c1c', textAlign: 'center', marginBottom: '30px' }}>
            Skill Lab - Rawalpindi Institute of Cardiology
          </h2>
          <p style={{ fontSize: '1.15rem', lineHeight: '1.8', marginBottom: '20px' }}>
            The <strong>Skill Lab</strong> at Rawalpindi Institute of Cardiology (RIC) is a cutting-edge simulation center designed to enhance clinical competencies among healthcare professionals. This dedicated facility bridges the gap between theoretical knowledge and practical application through interactive, hands-on training.
          </p>
          <p style={{ fontSize: '1.15rem', lineHeight: '1.8', marginBottom: '20px' }}>
            Medical students, nurses, and resident doctors utilize the Skill Lab to perform live demonstrations and simulations on high-fidelity manikins or dummy patients under expert supervision. These simulations encompass cardiac life support, emergency procedures, catheter insertion, CPR, and surgical practices. By providing a safe and controlled environment, the Skill Lab allows practitioners to rehearse real-life scenarios, improve decision-making skills, and foster effective teamwork.
          </p>
          <p style={{ fontSize: '1.15rem', lineHeight: '1.8', marginBottom: '20px' }}>
            RIC's commitment to excellence in medical training is further evidenced by its recognition from the <strong>College of Physicians & Surgeons of Pakistan (CPSP)</strong> for FCPS training programs. The institute offers a range of educational opportunities, including fellowship programs, house job and internship programs, and various workshops and training sessions. These programs are designed to equip healthcare professionals with the necessary skills and knowledge to excel in their respective fields.
          </p>
          <p style={{ fontSize: '1.15rem', lineHeight: '1.8', marginBottom: '20px' }}>
            In addition to the Skill Lab, RIC houses several specialized departments, such as the Echocardiography Department, which provides comprehensive diagnostic services. The institute's infrastructure and resources are continually developed and maintained by dedicated departments to ensure the highest standards of patient care and medical education.
          </p>
          <p style={{ fontSize: '1.15rem', lineHeight: '1.8' }}>
            Through its state-of-the-art facilities and comprehensive training programs, the Rawalpindi Institute of Cardiology continues to play a pivotal role in advancing cardiac care and medical education in Pakistan. The Skill Lab exemplifies RIC’s broader mission—to nurture a new generation of healthcare professionals who are not only technically skilled but also adept in clinical judgment, communication, and teamwork.
          </p>

          {/* Add more paragraphs or bullet sections here if you want to expand to a full 3000 words.
              You can include: types of simulators, case scenarios, daily schedule, trainer details, testimonials, etc. */}

          {/* Image Gallery */}
          <div style={{
            marginTop: '40px',
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
            gap: '20px'
          }}>
            {galleryImages.map((src, index) => (
              <img
                key={index}
                src={src}
                alt={`Skill Lab ${index + 1}`}
                onClick={() => setSelectedImage(src)}
                style={{
                  width: '100%',
                  height: '200px',
                  objectFit: 'cover',
                  borderRadius: '12px',
                  cursor: 'pointer',
                  transition: 'transform 0.3s',
                }}
                onMouseOver={e => e.currentTarget.style.transform = 'scale(1.03)'}
                onMouseOut={e => e.currentTarget.style.transform = 'scale(1)'}
              />
            ))}
          </div>
        </div>
      </section>

      {/* Image Modal Preview */}
      {selectedImage && (
        <div onClick={() => setSelectedImage(null)} style={{
          position: 'fixed',
          top: 0, left: 0,
          width: '100vw', height: '100vh',
          backgroundColor: 'rgba(0, 0, 0, 0.8)',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          zIndex: 9999,
        }}>
          <img src={selectedImage} alt="Preview" style={{
            maxWidth: '90%',
            maxHeight: '90%',
            borderRadius: '10px',
            boxShadow: '0 10px 25px rgba(0, 0, 0, 0.3)'
          }} />
        </div>
      )}
    </main>
  );
};

export default SkillLab;
